module.exports = "\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reportinginstructions/fileupload/fileupload.component.html
// module id = ./src/app/reportinginstructions/fileupload/fileupload.component.html
// module chunks = main